// RAL Color Database
// Comprehensive RAL color codes with hex values and names

// RAL Classic colors with approximate hex values
// Note: These are approximate values. For production, use official RAL color specifications
export const ralColors = [
  // Existing colors mapped to RAL codes
  { ral: '7016', name: 'Anthracite Grey', hex: '#3D3D3D', category: 'grey' },
  { ral: '9005', name: 'Jet Black', hex: '#1A1A1A', category: 'black' },
  { ral: '9010', name: 'Pure White', hex: '#FFFFFF', category: 'white' },
  { ral: '8017', name: 'Chocolate Brown', hex: '#5C4033', category: 'brown' },
  { ral: '1001', name: 'Beige', hex: '#C9B896', category: 'beige' },
  { ral: '6009', name: 'Fir Green', hex: '#2C5F2D', category: 'green' },
  { ral: '5008', name: 'Grey Blue', hex: '#4A7C8C', category: 'blue' },
  { ral: '8024', name: 'Beige Brown', hex: '#A5784C', category: 'brown' },
  { ral: '9001', name: 'Cream', hex: '#F7F5E6', category: 'beige' },
  { ral: '9016', name: 'Traffic White', hex: '#F1F0EA', category: 'white' },
  
  // Additional RAL colors from user's list
  { ral: '0831', name: 'RAL 0831', hex: '#8B7355', category: 'brown' },
  { ral: '0752', name: 'RAL 0752', hex: '#B8A082', category: 'beige' },
  { ral: '0753', name: 'RAL 0753', hex: '#D4C4A8', category: 'beige' },
  { ral: '0720', name: 'RAL 0720', hex: '#8B6F47', category: 'brown' },
  { ral: '0721', name: 'RAL 0721', hex: '#A67C52', category: 'brown' },
  { ral: '0898', name: 'RAL 0898', hex: '#4A4A4A', category: 'grey' },
  { ral: '0866', name: 'RAL 0866', hex: '#6B6B6B', category: 'grey' },
  { ral: '0766', name: 'RAL 0766', hex: '#9B8B7A', category: 'grey' },
  { ral: '0366', name: 'RAL 0366', hex: '#FF6B00', category: 'orange' },
  { ral: '0875', name: 'RAL 0875', hex: '#5C4A3A', category: 'brown' },
  { ral: '0830', name: 'RAL 0830', hex: '#7A6B5A', category: 'brown' },
  { ral: '0045', name: 'RAL 0045', hex: '#FFB400', category: 'yellow' },
  { ral: '0352', name: 'RAL 0352', hex: '#FF8C00', category: 'orange' },
  { ral: '0799', name: 'RAL 0799', hex: '#8B7355', category: 'brown' },
  { ral: '0863', name: 'RAL 0863', hex: '#6B5B4A', category: 'brown' },
  { ral: '0080', name: 'RAL 0080', hex: '#FFD700', category: 'yellow' },
  { ral: '0732', name: 'RAL 0732', hex: '#5C4A3A', category: 'brown' },
  { ral: '0362', name: 'RAL 0362', hex: '#FF8C00', category: 'orange' },
  { ral: '0801', name: 'RAL 0801', hex: '#4A3A2A', category: 'brown' },
  { ral: '0508', name: 'RAL 0508', hex: '#FF6B6B', category: 'red' },
  { ral: '0802', name: 'RAL 0802', hex: '#3A2A1A', category: 'brown' },
  { ral: '0062', name: 'RAL 0062', hex: '#FFA500', category: 'orange' },
  { ral: '0512', name: 'RAL 0512', hex: '#FF4D4D', category: 'red' },
  { ral: '0611', name: 'RAL 0611', hex: '#8B8B8B', category: 'grey' },
  { ral: '0242', name: 'RAL 0242', hex: '#FF8C42', category: 'orange' },
  { ral: '0125', name: 'RAL 0125', hex: '#FFD700', category: 'yellow' },
  { ral: '0128', name: 'RAL 0128', hex: '#FFC800', category: 'yellow' },
  { ral: '0246', name: 'RAL 0246', hex: '#FF6B42', category: 'orange' },
  { ral: '0077', name: 'RAL 0077', hex: '#FFA500', category: 'orange' },
  { ral: '0619', name: 'RAL 0619', hex: '#A0A0A0', category: 'grey' },
  { ral: '0042', name: 'RAL 0042', hex: '#FFB84D', category: 'yellow' },
  { ral: '0503', name: 'RAL 0503', hex: '#FF8C8C', category: 'pink' },
  { ral: '0437', name: 'RAL 0437', hex: '#FF6B9D', category: 'pink' },
  { ral: '0511', name: 'RAL 0511', hex: '#FF4D6B', category: 'red' },
  { ral: '0055', name: 'RAL 0055', hex: '#FFC84D', category: 'yellow' },
  { ral: '0646', name: 'RAL 0646', hex: '#B0B0B0', category: 'grey' },
  { ral: '0804', name: 'RAL 0804', hex: '#6B5B4A', category: 'brown' },
  { ral: '0895', name: 'RAL 0895', hex: '#5A5A5A', category: 'grey' },
  { ral: '0639', name: 'RAL 0639', hex: '#C0C0C0', category: 'grey' },
  { ral: '0079', name: 'RAL 0079', hex: '#FFB84D', category: 'yellow' },
  { ral: '0095', name: 'RAL 0095', hex: '#FFD84D', category: 'yellow' },
  { ral: '0805', name: 'RAL 0805', hex: '#7A6B5A', category: 'brown' },
  { ral: '0119', name: 'RAL 0119', hex: '#FFE64D', category: 'yellow' },
  { ral: '0053', name: 'RAL 0053', hex: '#FFB84D', category: 'yellow' },
  { ral: '0853', name: 'RAL 0853', hex: '#4A4A4A', category: 'grey' },
  { ral: '0393', name: 'RAL 0393', hex: '#FF8C6B', category: 'orange' },
  { ral: '0967', name: 'RAL 0967', hex: '#8B8B6B', category: 'green' },
  { ral: '0811', name: 'RAL 0811', hex: '#5C4A3A', category: 'brown' },
  { ral: '0849', name: 'RAL 0849', hex: '#6B5B4A', category: 'brown' },
  { ral: '0049', name: 'RAL 0049', hex: '#FFB84D', category: 'yellow' },
  { ral: '0859', name: 'RAL 0859', hex: '#5A4A3A', category: 'brown' },
  { ral: '0117', name: 'RAL 0117', hex: '#FFD84D', category: 'yellow' },
  { ral: '0052', name: 'RAL 0052', hex: '#FFB84D', category: 'yellow' },
  { ral: '0291', name: 'RAL 0291', hex: '#FF8C6B', category: 'orange' },
  { ral: '0154', name: 'RAL 0154', hex: '#FFC84D', category: 'yellow' },
  { ral: '0153', name: 'RAL 0153', hex: '#FFB84D', category: 'yellow' },
  { ral: '0127', name: 'RAL 0127', hex: '#FFC84D', category: 'yellow' },
  { ral: '0126', name: 'RAL 0126', hex: '#FFB84D', category: 'yellow' },
  { ral: '0068', name: 'RAL 0068', hex: '#FFA54D', category: 'yellow' },
  { ral: '0162', name: 'RAL 0162', hex: '#FFD84D', category: 'yellow' },
  { ral: '0509', name: 'RAL 0509', hex: '#FF6B8C', category: 'pink' },
  { ral: '0195', name: 'RAL 0195', hex: '#FFC84D', category: 'yellow' },
  { ral: '0193', name: 'RAL 0193', hex: '#FFB84D', category: 'yellow' },
  { ral: '0142', name: 'RAL 0142', hex: '#FFC84D', category: 'yellow' },
  { ral: '0039', name: 'RAL 0039', hex: '#FFA54D', category: 'yellow' },
  { ral: '0731', name: 'RAL 0731', hex: '#6B5B4A', category: 'brown' },
  { ral: '0730', name: 'RAL 0730', hex: '#7A6B5A', category: 'brown' },
  { ral: '0722', name: 'RAL 0722', hex: '#9B8B7A', category: 'brown' },
  { ral: '0093', name: 'RAL 0093', hex: '#FFD84D', category: 'yellow' },
  { ral: '0809', name: 'RAL 0809', hex: '#8B7A6B', category: 'brown' },
  { ral: '0067', name: 'RAL 0067', hex: '#FFA54D', category: 'yellow' },
  { ral: '0118', name: 'RAL 0118', hex: '#FFE64D', category: 'yellow' },
  { ral: '0168', name: 'RAL 0168', hex: '#FFD84D', category: 'yellow' },
  { ral: '0167', name: 'RAL 0167', hex: '#FFC84D', category: 'yellow' },
  { ral: '0096', name: 'RAL 0096', hex: '#FFE64D', category: 'yellow' },
  { ral: '0051', name: 'RAL 0051', hex: '#FFB84D', category: 'yellow' },
  { ral: '0796', name: 'RAL 0796', hex: '#A08B7A', category: 'brown' },
  { ral: '0785', name: 'RAL 0785', hex: '#B89B8B', category: 'brown' },
  { ral: '0797', name: 'RAL 0797', hex: '#C0A08B', category: 'brown' },
  { ral: '0149', name: 'RAL 0149', hex: '#FFC84D', category: 'yellow' },
  { ral: '0723', name: 'RAL 0723', hex: '#8B7A6B', category: 'brown' },
  { ral: '0617', name: 'RAL 0617', hex: '#B0B0B0', category: 'grey' },
  { ral: '0767', name: 'RAL 0767', hex: '#9B8B7A', category: 'brown' },
  { ral: '0765', name: 'RAL 0765', hex: '#8B7A6B', category: 'brown' },
  { ral: '0749', name: 'RAL 0749', hex: '#C0A08B', category: 'brown' },
  { ral: '0641', name: 'RAL 0641', hex: '#C8C8C8', category: 'grey' },
  { ral: '0867', name: 'RAL 0867', hex: '#5A5A5A', category: 'grey' },
  { ral: '0618', name: 'RAL 0618', hex: '#A8A8A8', category: 'grey' },
  { ral: '0733', name: 'RAL 0733', hex: '#7A6B5A', category: 'brown' },
  { ral: '0020', name: 'RAL 0020', hex: '#FFB84D', category: 'yellow' },
  { ral: '0438', name: 'RAL 0438', hex: '#FF6B9D', category: 'pink' },
  { ral: '0059', name: 'RAL 0059', hex: '#FFB84D', category: 'yellow' },
  { ral: '0028', name: 'RAL 0028', hex: '#FFA54D', category: 'yellow' },
  { ral: '0507', name: 'RAL 0507', hex: '#FF8C8C', category: 'pink' },
  { ral: '0058', name: 'RAL 0058', hex: '#FFB84D', category: 'yellow' },
  { ral: '0035', name: 'RAL 0035', hex: '#FFA54D', category: 'yellow' },
  { ral: '0011', name: 'RAL 0011', hex: '#FFB84D', category: 'yellow' },
  { ral: '0029', name: 'RAL 0029', hex: '#FFA54D', category: 'yellow' },
  { ral: '0030', name: 'RAL 0030', hex: '#FFA54D', category: 'yellow' },
  { ral: '0027', name: 'RAL 0027', hex: '#FFA54D', category: 'yellow' },
  { ral: '0813', name: 'RAL 0813', hex: '#6B5B4A', category: 'brown' },
  { ral: '0034', name: 'RAL 0034', hex: '#FFA54D', category: 'yellow' },
  { ral: '0033', name: 'RAL 0033', hex: '#FFA54D', category: 'yellow' },
  { ral: '0032', name: 'RAL 0032', hex: '#FFA54D', category: 'yellow' },
  { ral: '0031', name: 'RAL 0031', hex: '#FFA54D', category: 'yellow' },
  { ral: '0040', name: 'RAL 0040', hex: '#FFA54D', category: 'yellow' },
  { ral: '0702', name: 'RAL 0702', hex: '#4A4A4A', category: 'grey' },
  { ral: '0705', name: 'RAL 0705', hex: '#5A5A5A', category: 'grey' },
  { ral: '0706', name: 'RAL 0706', hex: '#6B6B6B', category: 'grey' },
  { ral: '0707', name: 'RAL 0707', hex: '#7A7A7A', category: 'grey' },
  { ral: '0847', name: 'RAL 0847', hex: '#5A4A3A', category: 'brown' },
  { ral: '0143', name: 'RAL 0143', hex: '#FFC84D', category: 'yellow' },
  { ral: '0089', name: 'RAL 0089', hex: '#FFB84D', category: 'yellow' },
  { ral: '0064', name: 'RAL 0064', hex: '#FFA54D', category: 'yellow' },
  { ral: '0789', name: 'RAL 0789', hex: '#B89B8B', category: 'brown' },
  { ral: '0389', name: 'RAL 0389', hex: '#FF8C6B', category: 'orange' },
  { ral: '0070', name: 'RAL 0070', hex: '#FFA54D', category: 'yellow' },
  { ral: '0488', name: 'RAL 0488', hex: '#FF6B8C', category: 'pink' },
  { ral: '0074', name: 'RAL 0074', hex: '#FFA54D', category: 'yellow' },
  { ral: '0065', name: 'RAL 0065', hex: '#FFA54D', category: 'yellow' },
  { ral: '0075', name: 'RAL 0075', hex: '#FFA54D', category: 'yellow' },
  { ral: '0078', name: 'RAL 0078', hex: '#FFA54D', category: 'yellow' },
  { ral: '0092', name: 'RAL 0092', hex: '#FFD84D', category: 'yellow' },
  { ral: '0056', name: 'RAL 0056', hex: '#FFB84D', category: 'yellow' },
  { ral: '0090', name: 'RAL 0090', hex: '#FFD84D', category: 'yellow' },
  { ral: '0832', name: 'RAL 0832', hex: '#7A6B5A', category: 'brown' },
  { ral: '0087', name: 'RAL 0087', hex: '#FFB84D', category: 'yellow' },
  { ral: '0071', name: 'RAL 0071', hex: '#FFA54D', category: 'yellow' },
  { ral: '0910', name: 'RAL 0910', hex: '#E8E8E8', category: 'white' },
  { ral: '9006', name: 'RAL 9006', hex: '#A5A5A5', category: 'grey' },
];

// Helper function to get color by RAL code
export const getColorByRAL = (ralCode) => {
  return ralColors.find(color => color.ral === String(ralCode).padStart(4, '0'));
};

// Helper function to get color by ID (for backward compatibility)
export const getColorById = (id) => {
  if (!id) return null;
  
  // Handle 'ral-XXXX' format from ColorPicker
  if (String(id).startsWith('ral-')) {
    const ralCode = String(id).substring(4); // Extract RAL code after 'ral-'
    const ralMatch = ralColors.find(color => color.ral === ralCode.padStart(4, '0'));
    if (ralMatch) return ralMatch;
  }
  
  // Try to find by RAL code directly (padded to 4 digits)
  const ralMatch = ralColors.find(color => color.ral === String(id).padStart(4, '0'));
  if (ralMatch) return ralMatch;
  
  // Then try legacy IDs
  const legacyMap = {
    'anthracite': '7016',
    'black': '9005',
    'white': '9010',
    'brown': '8017',
    'beige': '1001',
    'green': '6009',
    'blue': '5008',
    'wood': '8024'
  };
  
  if (legacyMap[id]) {
    return getColorByRAL(legacyMap[id]);
  }
  
  return null;
};

// Color categories for filtering
export const colorCategories = [
  'all',
  'white',
  'black',
  'grey',
  'brown',
  'beige',
  'yellow',
  'orange',
  'red',
  'pink',
  'green',
  'blue'
];



